import ErrorMessage from '@components/atoms/ErrorMessage';
import {
  ManufacturingYearFormResult,
  QuoteInitialForm
} from '@lib/data/typesQuestions';
import FormField from 'components/atoms/FormField';
import GridBox from 'components/atoms/GridBox';
import OnboardingButtonBar from 'components/molecules/button-bar/OnboardingButtonBar';
import React, { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';

interface Props {
  onSubmit: (data: ManufacturingYearFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const ManufacturingYearForm: FC<Props> = ({ onSubmit, loading, item }) => {
  const { handleSubmit, control, errors } =
    useForm<{ year: { value: string } }>();

  return (
    <form
      onSubmit={handleSubmit((data) => {
        if (item.vehicle)
          onSubmit({
            vehicle: {
              ...item.vehicle,
              manufacturingYear: Number(data.year.value),
            },
          });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }} >
            <Controller
              name="year"
              control={control}
              defaultValue={
                item.vehicle?.manufacturingYear
                  ? {
                      value: item.vehicle?.manufacturingYear,
                      label: item.vehicle?.manufacturingYear,
                    }
                  : {
                      value: (item.vehicle?.modelYear as number) - 1,
                      label: (item.vehicle?.modelYear as number) - 1,
                    }
              }
              rules={{ required: 'Precisamos do ano de fabricação moto' }}
              render={(field) => (
                <Select
                  {...field}
                  options={[
                    {
                      value: item.vehicle?.modelYear as number,
                      label: item.vehicle?.modelYear,
                    },
                    {
                      value: (item.vehicle?.modelYear as number) - 1,
                      label: (item.vehicle?.modelYear as number) - 1,
                    },
                  ].filter(({ value }) => new Date().getFullYear() >= value)}
                  placeholder="Qual o ano de fabricação?"
                  isSearchable={false}
                />
              )}
            />
            {(errors.year as { message?: string })?.message && (
              <ErrorMessage>
                {(errors.year as { message?: string }).message}
              </ErrorMessage>
            )}
          </FormField>
        </GridBox>
      </GridBox>
      <OnboardingButtonBar loading={loading} />
    </form>
  );
};

export default ManufacturingYearForm;
